import React from 'react';

import styled from 'styled-components';
import { RiTwitterXFill } from 'react-icons/ri';
import { CiMail, CiLinkedin, CiFileOn } from 'react-icons/ci';

const PageWrapper = styled.div`
  padding-left: 5rem;
  padding-right: 180px;
  z-index: 1;
  @media (max-width: 768px) {
    padding-left: 1rem;
    padding-right: 100px;
  }
`;

const HomePageContent = styled.div`
  position: relative;
  height: 100vh;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

const HeroTextContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding-bottom: 0;
`;

const BigFont = styled.h1`
  font-size: 10vw;
  margin-bottom: 0;
  @media (max-width: 768px) {
    font-size: 100px;
  }
`;

const ShortBio = styled.h3`
  font-size: 2.5vw;
  border-bottom: 3px solid black;
  @media (max-width: 768px) {
    font-size: 22px;
  }
`;

const SocialLinksContainer = styled.div`
  display: flex;
  gap: 2rem;
  margin-top: 1rem;
  padding-bottom: 2rem;
`;

const SocialLink = styled.a`
  text-decoration: none;
  color: #000;
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
  padding-bottom: 4px;

  svg {
    width: 30px;
    height: 30px;
    transition: transform 0.3s ease;
  }

  &:hover {
    svg {
      transform: translateY(-2px);
    }

    &::after {
      width: 100%;
    }
  }

  &::after {
    content: '';
    position: absolute;
    width: 0;
    height: 1px;
    bottom: 0;
    left: 0;
    background-color: #000;
    transition: width 0.3s ease;
  }

  @media (max-width: 768px) {
    span {
      display: none; /* Hides the text on mobile */
    }

    svg {
      width: 24px; /* Slightly smaller icons on mobile */
      height: 24px;
    }

    gap: 0; /* Remove gap since we don't have text */
  }
`;

const About = () => {
  return (
    <PageWrapper>
      <HomePageContent>
        <HeroTextContainer>
          <BigFont>Hi, I'm Jesse!</BigFont>
          <ShortBio>
            I'm an interaction researcher / designer, interested in Human
            Digitization.
            <br />
            XR Experience | Spatial Computing
          </ShortBio>
          <SocialLinksContainer>
            <SocialLink href="mailto:chenfenggao2029@u.northwestern.edu">
              <CiMail />
              <span>Email</span>
            </SocialLink>
            <SocialLink
              href="https://www.linkedin.com/in/chenfeng-jesse-gao-a40229110/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <CiLinkedin />
              <span>LinkedIn</span>
            </SocialLink>
            <SocialLink
              href="https://x.com/JesseGao13"
              target="_blank"
              rel="noopener noreferrer"
            >
              <RiTwitterXFill />
              <span>Twitter</span>
            </SocialLink>
            <SocialLink
              href="/cv/jesse-gao-cv.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              <CiFileOn />
              <span>Link to my CV</span>
            </SocialLink>
          </SocialLinksContainer>
        </HeroTextContainer>
      </HomePageContent>
    </PageWrapper>
  );
};

export default About;
